import { request } from './client'

export interface FeedbackPayload {
  category?: string
  title?: string
  description: string
  screenshot?: string
  page_url: string
}

export async function submitFeedback(data: FeedbackPayload, idempotencyKey?: string): Promise<void> {
  await request<void>('/feedback', {
    method: 'POST',
    body: JSON.stringify(data),
    idempotencyKey,
  })
}
